(() => {
  let accepted = false;
  let revision = 0;
  let pending = Promise.resolve();
  const root = window.Shopify?.routes?.root || '/';
  const boxes = () => [...document.querySelectorAll('[data-mjs-agree]')];
  const status = text => document.querySelectorAll('[data-mjs-agreement-status]').forEach(el => { el.textContent = text; });
  function sync() {
    const ready = accepted ? 'true' : 'false';
    if (document.documentElement.dataset.mjsTermsReady !== ready) document.documentElement.dataset.mjsTermsReady = ready;
    boxes().forEach(box => { if (box.checked !== accepted) box.checked = accepted; });
    document.querySelectorAll('[data-mjs-guarded-checkout]').forEach(button => {
      const disabled = !accepted || button.dataset.mjsEmpty === 'true';
      if (button.disabled !== disabled) button.disabled = disabled;
    });
  }
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-mjs-agree]')) return;
    const wanted = event.target.checked;
    const current = ++revision;
    accepted = false;
    sync();
    const block = event.target.closest('[data-mjs-agreement]');
    status(block.dataset.saving);
    const time = wanted ? new Date().toISOString() : '';
    pending = pending.catch(() => {}).then(async () => {
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({attributes: {'MJS terms version': wanted ? '2026-10-02' : '', 'MJS terms accepted at': time, 'MJS standard delivery': wanted ? '7–12 business days from purchase to arrival' : ''}})
      });
      if (!response.ok) throw new Error('Agreement could not be recorded');
      if (current !== revision) return;
      accepted = wanted;
      document.querySelectorAll('.mjs-pdp__form').forEach(form => {
        for (const [name, value] of Object.entries({'properties[MJS terms version]': wanted ? '2026-10-02' : '', 'properties[MJS terms accepted at]': time})) {
          let input = form.querySelector('input[name="' + name + '"]');
          if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.append(input); }
          input.value = value;
        }
      });
      status(''); sync();
    }).catch(() => { if (current === revision) { accepted = false; status(block.dataset.failed); sync(); } });
  });
  function blockCheckout(event) {
    const target = event.target.closest?.('[name="checkout"],a[href^="/checkout"],a[href*="/checkouts/"]');
    const submit = event.type === 'submit' && (event.submitter?.name === 'checkout' || /\/checkout(?:\/|$)/.test(event.target.action || ''));
    if (!accepted && (target || submit)) {
      event.preventDefault(); event.stopImmediatePropagation();
      const agreement = [...document.querySelectorAll('[data-mjs-agreement]')].find(el => el.getClientRects().length);
      if (agreement) { status(agreement.dataset.required); agreement.querySelector('input')?.focus(); }
    }
  }
  document.addEventListener('click', blockCheckout, true);
  document.addEventListener('submit', blockCheckout, true);
  new MutationObserver(sync).observe(document.body, {childList: true, subtree: true});
  sync();

  document.querySelectorAll('[data-mjs-fit]').forEach(host => {
    const cfg = JSON.parse(host.querySelector('[data-mjs-fit-config]').textContent);
    const text = cfg.text;
    const sizeOptions = cfg.options.filter(option => /size/i.test(option.name));
    if (!sizeOptions.length) { host.hidden = true; return; }
    const dialog = host.querySelector('dialog');
    const form = host.querySelector('form');
    const result = host.querySelector('[data-mjs-fit-result]');
    const key = 'mjs-fit-v1:' + host.dataset.profileKey;
    const measurements = ['height','weight','chest','waist','hip','inseam'];
    let profile = {};
    try { profile = JSON.parse(localStorage.getItem(key) || '{}'); } catch (_) {}
    const usualHost = host.querySelector('[data-mjs-usual-sizes]');
    for (const option of sizeOptions) {
      const label = document.createElement('label');
      label.textContent = text.usual + ' — ' + option.name;
      const select = document.createElement('select');
      select.name = 'usual-' + option.index; select.required = !cfg.aiEnabled;
      select.add(new Option(text.choose, ''));
      option.values.forEach(value => select.add(new Option(value, value)));
      label.append(select); usualHost.append(label);
    }
    const previous = profile.products?.[cfg.handle] || {};
    for (const name of measurements) if (profile[name]) form.elements[name].value = profile[name];
    form.elements.units.value = profile.units === 'metric' ? 'metric' : 'imperial';
    form.elements.fit.value = previous.fit || 'intended';
    for (const option of sizeOptions) form.elements['usual-' + option.index].value = previous.usual?.[option.index] || '';
    form.elements.remember.checked = !!profile.savedAt;
    function syncHeight() {
      const metric = form.elements.units.value === 'metric';
      form.elements.height.value = metric ? form.elements.heightCm.value :
        (form.elements.heightFeet.value && form.elements.heightInches.value !== '' ?
          String(Number(form.elements.heightFeet.value) * 12 + Number(form.elements.heightInches.value)) : '');
    }
    function renderHeight() {
      const metric = form.elements.units.value === 'metric';
      host.querySelector('[data-mjs-height-imperial]').hidden = metric;
      host.querySelector('[data-mjs-height-metric]').hidden = !metric;
      for (const name of ['heightFeet','heightInches']) {
        form.elements[name].disabled = metric; form.elements[name].required = !metric;
      }
      form.elements.heightCm.disabled = !metric; form.elements.heightCm.required = metric;
      const height = Number(form.elements.height.value);
      form.elements.heightCm.value = metric && height ? height : '';
      const total = metric ? 0 : Math.round(height * 10) / 10;
      form.elements.heightFeet.value = total ? Math.floor(total / 12) : '';
      form.elements.heightInches.value = total ? Number((total % 12).toFixed(1)) : '0';
    }
    for (const name of ['heightFeet','heightInches','heightCm']) form.elements[name].addEventListener('input', syncHeight);
    function labels() {
      const metric = form.elements.units.value === 'metric';
      for (const name of measurements) {
        const el = host.querySelector('[data-mjs-' + name + '-label]');
        if (el) el.textContent = text[name + '_' + (name === 'weight' ? (metric ? 'kg' : 'lb') : (metric ? 'cm' : 'in'))];
      }
      renderHeight();
      form.elements.weight.min = metric ? '18' : '40'; form.elements.weight.max = metric ? '318' : '700';
    }
    let oldUnits = form.elements.units.value;
    form.elements.units.addEventListener('change', () => {
      const next = form.elements.units.value;
      if (next !== oldUnits) for (const name of measurements) {
        const input = form.elements[name]; if (!input.value) continue;
        const factor = name === 'weight' ? 0.45359237 : 2.54;
        input.value = (Number(input.value) * (next === 'metric' ? factor : 1 / factor)).toFixed(1);
      }
      oldUnits = next; labels(); result.hidden = true;
    });
    labels();
    host.querySelector('[data-mjs-fit-open]').addEventListener('click', () => dialog.showModal());
    host.querySelector('[data-mjs-fit-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
    host.querySelector('[data-mjs-fit-forget]').addEventListener('click', () => {
      try { localStorage.removeItem(key); } catch (_) {}
      profile = {}; form.reset(); oldUnits = 'imperial'; labels(); result.hidden = false; result.textContent = text.forgotten;
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      syncHeight();
      if (!form.reportValidity()) return;
      const fit = form.elements.fit.value;
      const choices = {};
      const usual = {};
      const submit = form.querySelector('[type=submit]');
      if (submit.disabled) return;
      let ai = null;
      for (const option of sizeOptions) usual[option.index] = form.elements['usual-' + option.index].value;
      if (cfg.aiEnabled) {
        submit.disabled = true;
        result.hidden = false; result.textContent = text.loading;
        try {
          const bodyProfile = {units: form.elements.units.value, fit};
          measurements.forEach(name => { bodyProfile[name] = form.elements[name].value ? Number(form.elements[name].value) : null; });
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'apps/mjs-sizing/recommend', {
            method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({handle: cfg.handle, profile: bodyProfile, consent: form.elements.aiConsent?.checked === true}),
            signal: AbortSignal.timeout(30000)
          });
          ai = await response.json();
          if (!response.ok || ai.kind !== 'ai' || !ai.sizes || !['low','medium'].includes(ai.confidence) || typeof ai.explanation !== 'string' || !Array.isArray(ai.questions) || ai.questions.some(q => typeof q !== 'string')) throw new Error('INVALID_AI_RESPONSE');
          for (const option of sizeOptions) {
            const component = /hoodie/i.test(option.name) ? 'hoodie' : /pant/i.test(option.name + ' ' + cfg.handle) ? 'pants' : 'top';
            const size = ai.sizes[component];
            if (size !== null && !option.values.includes(size)) throw new Error('INVALID_AI_SIZE');
            choices[option.index] = size;
          }
        } catch (_) { result.textContent = text.ai_failed; return; }
        finally { submit.disabled = false; }
      } else {
        for (const option of sizeOptions) {
          let index = option.values.indexOf(usual[option.index]);
          if (cfg.handle === 'origin-layered-tee') index += fit === 'closer' ? -1 : fit === 'roomier' ? 1 : 0;
          if (index < 0 || index >= option.values.length) { result.hidden = false; result.textContent = text.outside; return; }
          choices[option.index] = option.values[index];
        }
      }
      result.replaceChildren(); result.hidden = false;
      const title = document.createElement('strong'); title.textContent = ai ? text.ai_title : text.starting;
      result.append(title);
      for (const option of sizeOptions) { const p = document.createElement('p'); p.textContent = option.name + ': ' + (choices[option.index] || text.ai_missing); result.append(p); }
      const note = document.createElement('p'); note.textContent = ai ? ai.explanation : cfg.handle === 'origin-layered-tee' ? text.origin_note : text.general_note;
      result.append(note);
      const caveat = document.createElement('p'); caveat.textContent = ai ? text.ai_note : text.provisional; result.append(caveat);
      if (ai) for (const question of ai.questions) { const p = document.createElement('p'); p.textContent = question; result.append(p); }
      const nativeForm = document.querySelector('.mjs-pdp__form');
      const selectedId = Number(nativeForm?.querySelector('[name="id"]')?.value);
      const variants = JSON.parse(document.querySelector('[data-mjs-variants]')?.textContent || '[]');
      const current = variants.find(v => v.id === selectedId) || variants[0];
      const complete = sizeOptions.every(option => !!choices[option.index]);
      const matching = complete && variants.find(v => v.available && v.options.every((value, index) => choices[index] ? value === choices[index] : value === current?.options[index]));
      if (matching) {
        const a = document.createElement('a'); a.textContent = text.select; a.className = 'mjs-fit-link';
        const url = new URL(location.href); url.searchParams.set('variant', matching.id); a.href = url.href;
        a.addEventListener('click', event => {
          const detail = {id: matching.id, applied: false};
          host.dispatchEvent(new CustomEvent('mjs:fit-select', {detail, bubbles: true}));
          if (detail.applied) { event.preventDefault(); dialog.close(); }
        });
        result.append(a);
      } else { const p = document.createElement('p'); p.textContent = text.unavailable; result.append(p); }
      if (form.elements.remember.checked) {
        const saved = {...profile, units: form.elements.units.value, savedAt: Date.now(), products: {...profile.products, [cfg.handle]: {usual, choices, fit}}};
        measurements.forEach(name => { saved[name] = form.elements[name].value; });
        try { localStorage.setItem(key, JSON.stringify(saved)); profile = saved; } catch (_) { const p = document.createElement('p'); p.textContent = text.storage_failed; result.append(p); }
      } else { try { localStorage.removeItem(key); profile = {}; } catch (_) {} }
    });
  });
})();
